import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { APIProvider, Map, useMap } from '@vis.gl/react-google-maps';
import {  IonButton} from '@ionic/react';
//npm install @vis.gl/react-google-maps

export interface MapContainerRef {
  triggerGetAddress: () => void;
}

interface CustomMarkerProps {
  position: google.maps.LatLngLiteral
}

interface MapContainerProps {
  apiKey: string;
  onAddressFetched: (address: string) => void;
  onLatitudeFetched: (lat: number) => void; 
  onLongitudeFetched: (lon: number) => void; 
}

const CustomMarker: React.FC<CustomMarkerProps> = (props) => {
  const map = useMap(); 
  //const [address, setAddress] = useState<string>("กดปุ่มเพื่อดึงที่อยู่");

  useEffect(() => {
    if (!map) return;

   
    const marker = new google.maps.Marker({
      position: props.position,
      map: map,
    });

    
    return () => {
      marker.setMap(null);
    };
  }, [map, props.position]);

  return null; 
};

const MapContainer = forwardRef<MapContainerRef, MapContainerProps>(({ apiKey, onAddressFetched, onLatitudeFetched, onLongitudeFetched }, ref) => {
  //const [address, setAddress] = useState<string>("กดปุ่มเพื่อดึงที่อยู่");
  const API_KEY = apiKey;

   
   const [position, setPosition] = useState<google.maps.LatLngLiteral>({
    lat: 0.0,
    lng: 0.0
  });
  

  useEffect(() => {
   
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setPosition({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
          console.log(pos.coords.latitude);
          console.log(pos.coords.longitude);
        },
        (error) => {
          console.error("Error getting location:", error);
        },
        { enableHighAccuracy: true }
      );
    }
  }, []);

 
  const handleGetAddress = () => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: position }, (results, status) => {
      if (status === "OK" && results?.[0]) {
        //setAddress(results[0].formatted_address);
        //console.log(results[0].formatted_address);
        const fullAddress = results[0].formatted_address;
        const lat = position.lat;
        const lng = position.lng;
       
        onAddressFetched(fullAddress); 
        // ------------------------------------
        onLatitudeFetched(lat);
        onLongitudeFetched(lng);
        
        console.log("ส่งที่อยู่กลับไปแล้ว:", fullAddress);
      }
    });
  };


const getGeo = function() {
    const geocoder = new google.maps.Geocoder();
   // var isOk = false;
     geocoder.geocode({ location: position }, (results, status) => {
      if (status === "OK" && results?.[0]) {
        const lat = position.lat;
        const lng = position.lng;
        onAddressFetched(results[0].formatted_address);
        onLatitudeFetched(lat);
        onLongitudeFetched(lng);
        console.log("ส่งที่อยู่กลับไปแล้ว:", results[0].formatted_address);     
      }
    });
   
}
useImperativeHandle(ref, () => ({
  triggerGetAddress() {
    console.log("triggerGetAddress");
    setTimeout(() => {
      getGeo();
    }, 0);
  }
}));

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <APIProvider apiKey={API_KEY}>
        <Map
          center={{
            lat: position.lat,
            lng: position.lng,
          }}
          //onCenterChanged={(ev) => setPosition(ev.detail.center)}
          //defaultCenter={{ lat: 13.7563, lng: 100.5018 }}
          defaultZoom={13}
         
        >
          <CustomMarker position={{ lat: position.lat, lng: position.lng }} />
        </Map>
      </APIProvider>
     
    </div>
  );
});
// <IonButton onClick={handleGetAddress}>ดึงที่อยู่ (ปุ่มในตัวแมพ)</IonButton>
export default MapContainer;
